import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/AbpBase';
import { FieldType, CompareType } from '../../../store/entities/filter';
import PageRequest from '../../../store/entities/page-request';
import CreateTenant from './create-tenant.vue';
import EditTenant from './edit-tenant.vue';
var Tenants = /** @class */ (function (_super) {
    __extends(Tenants, _super);
    function Tenants() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filters = [
            { Type: FieldType.String, Value: '', FieldName: 'Name', CompareType: CompareType.Contains },
            { Type: FieldType.String, Value: '', FieldName: 'TenancyName', CompareType: CompareType.Contains },
            { Type: FieldType.Boolean, Value: null, FieldName: 'IsActive', CompareType: CompareType.Equal }
        ];
        _this.createModalShow = false;
        _this.editModalShow = false;
        _this.columns = [{
                title: _this.L('TenancyName'),
                key: 'tenancyName'
            }, {
                title: _this.L('TenantName'),
                key: 'name'
            }, {
                title: _this.L('IsActive'),
                render: function (h, params) {
                    return h('span', params.row.isActive ? _this.L('Yes') : _this.L('No'));
                }
            }, {
                title: _this.L('Actions'),
                key: 'Actions',
                width: 150,
                render: function (h, params) {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: function () {
                                    _this.$store.commit('tenant/edit', params.row);
                                    _this.edit();
                                }
                            }
                        }, _this.L('Edit')),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            on: {
                                click: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _this = this;
                                    return __generator(this, function (_a) {
                                        this.$Modal.confirm({
                                            title: this.L('Tips'),
                                            content: this.L('DeleteTenantConfirm'),
                                            okText: this.L('Yes'),
                                            cancelText: this.L('No'),
                                            onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, this.$store.dispatch({
                                                                type: 'tenant/delete',
                                                                data: params.row
                                                            })];
                                                        case 1:
                                                            _a.sent();
                                                            return [4 /*yield*/, this.getpage()];
                                                        case 2:
                                                            _a.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); }
                                        });
                                        return [2 /*return*/];
                                    });
                                }); }
                            }
                        }, _this.L('Delete'))
                    ]);
                }
            }];
        return _this;
    }
    Tenants.prototype.edit = function () {
        this.editModalShow = true;
    };
    Object.defineProperty(Tenants.prototype, "list", {
        get: function () {
            return this.$store.state.tenant.list;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Tenants.prototype, "loading", {
        get: function () {
            return this.$store.state.tenant.loading;
        },
        enumerable: true,
        configurable: true
    });
    Tenants.prototype.create = function () {
        this.createModalShow = true;
    };
    Tenants.prototype.isActiveChange = function (val) {
        if (val === 'Actived') {
            this.filters[2].Value = true;
        }
        else if (val === 'NoActive') {
            this.filters[2].Value = false;
        }
        else {
            this.filters[2].Value = null;
        }
    };
    Tenants.prototype.pageChange = function (page) {
        this.$store.commit('tenant/setCurrentPage', page);
        this.getpage();
    };
    Tenants.prototype.pagesizeChange = function (pagesize) {
        this.$store.commit('tenant/setPageSize', pagesize);
        this.getpage();
    };
    Tenants.prototype.getpage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var where, pagerequest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        where = Util.buildFilters(this.filters);
                        pagerequest = new PageRequest();
                        pagerequest.maxResultCount = this.pageSize;
                        pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
                        pagerequest.where = where;
                        return [4 /*yield*/, this.$store.dispatch({
                                type: 'tenant/getAll',
                                data: pagerequest
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Tenants.prototype, "pageSize", {
        get: function () {
            return this.$store.state.tenant.pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tenants.prototype, "totalCount", {
        get: function () {
            return this.$store.state.tenant.totalCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tenants.prototype, "currentPage", {
        get: function () {
            return this.$store.state.tenant.currentPage;
        },
        enumerable: true,
        configurable: true
    });
    Tenants.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.getpage();
                return [2 /*return*/];
            });
        });
    };
    Tenants = __decorate([
        Component({
            components: { CreateTenant: CreateTenant, EditTenant: EditTenant }
        })
    ], Tenants);
    return Tenants;
}(AbpBase));
export default Tenants;
